export const getSharepointFolderPath = (sharepointFolderObj) => {
    const fullPath = sharepointFolderObj?.["parentReference"]["path"] + "/" + sharepointFolderObj?.["name"];
    const pathArray = fullPath.split("/");
    return pathArray
}